export const productPath = (slug?: string) => `/deer-feeders/${slug}`;
